import { Fragment, ComponentPropsWithoutRef } from "react";
import { Link } from "react-router-dom";

import {
	Breadcrumb,
	BreadcrumbList,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "./Breadcrumb";

export type Crumb = {
	/** Already-translated label. */
	label: string;
	/** Router path; omit for the current (last) page. */
	to?: string;
};

type BreadcrumbsProps = {
	/** Ordered trail from root to current page. */
	items: Crumb[];
	/** Already-translated landmark label. Defaults to the "breadcrumb.label" translation. */
	label?: string;
} & ComponentPropsWithoutRef<"nav">;

/** Data-driven breadcrumb trail composing the primitives from an item list. */
export const Breadcrumbs = ({ items, label, ...props }: BreadcrumbsProps) => {
	const lastIndex = items.length - 1;

	return (
		<Breadcrumb label={label} {...props}>
			<BreadcrumbList>
				{items.map((item, index) => (
					<Fragment key={item.to ?? item.label}>
						<BreadcrumbItem>
							{item.to && index !== lastIndex ? (
								<BreadcrumbLink asChild>
									<Link to={item.to}>{item.label}</Link>
								</BreadcrumbLink>
							) : (
								<BreadcrumbPage>{item.label}</BreadcrumbPage>
							)}
						</BreadcrumbItem>
						{index < lastIndex && <BreadcrumbSeparator />}
					</Fragment>
				))}
			</BreadcrumbList>
		</Breadcrumb>
	);
};

Breadcrumbs.displayName = "Breadcrumbs";
